import { render } from "./TotalizadorDecorado.vue?vue&type=template&id=1205f0fe&scoped=true&ts=true"
import script from "./TotalizadorDecorado.vue?vue&type=script&lang=ts"
export * from "./TotalizadorDecorado.vue?vue&type=script&lang=ts"

import "./TotalizadorDecorado.vue?vue&type=style&index=0&id=1205f0fe&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1205f0fe"]])

export default __exports__